import React from 'react';
import { withTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Backend from '../../../../Layouts/Backend';
import { Formik, useFormik } from 'formik';
import {
  Alert,
  Button,
  Checkbox,
  Dropdown,
  Input,
} from '../../../../UI/Common';
import { Form, FormGroup, Label } from 'reactstrap';
import { validationSchema } from './validation';
import DeleteRecord from '../../../../UI/DeleteRecord';
import moment from 'moment';
import ReactSelect from '../../../../UI/ReactSelect';

const EditSensorPage = ({ t, ...props }) => {
  //prettier-ignore
  const { sensor = {}, group={}, sensorTypes, isSubmitting } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const { values, handleChange, errors, setFieldValue, touched, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: sensor,
      validationSchema,
      onSubmit,
    });
  // function displayFormat(typeId) {
  //   const result = sensorTypes.filter((type) => type.id === typeId)[0];
  //   if (!result) return '';
  //   const deptName = result.departmentName.trim();
  //   const typeName = result.typeName.trim();
  //   return `(${deptName}) ${typeName}`;
  // }
  function onSubmit(values) {
    if (
      sensor.calibrationDate ||
      moment(values.calibrationDate).isSame(moment(sensor.calibrationDate))
    ) {
      setOpenModal(true);
    } else {
      props.onEditSensor(values);
    }
  }
  return (
    <Backend title={`Edit Sensor: ${sensor.name || ''}`}>
      <DeleteRecord
        isOpen={openModal}
        title="Attention"
        body="Please note, Calibrated Date should not be changed unless the current calibrated date is incorrect. Are you sure you want to change this value?"
        onCancel={() => setOpenModal(false)}
        onConfirm={() => {
          props.onEditSensor(values);
          setOpenModal(false);
        }}
      />
      <div className="content-inner">
        <Alert.Error text={props.errors} />
        <h1>Edit Sensor for Group: {group.name}</h1>
        <Form className="w-50">
          <Input
            label="Model"
            id="model"
            value={values.model}
            onChange={handleChange('model')}
          />
          <Input readOnly label="Serial/Link" value={values.serialNo} />
          <Input
            required
            id="name"
            label="Name"
            value={values.name}
            onChange={handleChange('name')}
            invalid={touched.name}
            error={errors.name}
          />
          <Input
            id="location"
            label="Location"
            value={values.location}
            onChange={handleChange('location')}
            invalid={touched.location}
            error={errors.location}
          />
          <FormGroup>
            <Label htmlFor="calibrationDate">{t('Calibration Date')}</Label>
            <DatePicker
              id="calibrationDate"
              className="form-control"
              selected={values.calibrationDate}
              onChange={(date) => setFieldValue('calibrationDate', date)}
              popperClassName="z-99"
            />
          </FormGroup>
          <ReactSelect
            label="Type"
            options={sensorTypes}
            value={values.typeId}
            onChange={({ value }) => setFieldValue('typeId', value)}
            valueKey="id"
            labelKey="typeName"
            getOptionLabel={(obj) => `(${obj.departmentName}) ${obj.typeName}`}
          />
          {/* <Dropdown
            type="dynamic"
            label="Type"
            data={sensorTypes}
            value={values.typeId}
            onChange={({ value }) => setFieldValue('typeId', value)}
            valueKey="id"
            nameKey={['departmentName', 'typeName']}
            custom={{
              displayFormat: displayFormat(values.typeId),
            }}
          /> */}
          <Checkbox
            id="active"
            label="Active"
            checked={values.active}
            onChange={(isCheck) => setFieldValue('active', isCheck)}
          />
          <Checkbox
            id="alarms"
            label="Alerts"
            checked={values.alarms}
            onChange={(isCheck) => setFieldValue('alarms', isCheck)}
          />
          <Button loading={isSubmitting} onClick={handleSubmit}>
            <i className="md-icon">done</i>
            {t('Save')}
          </Button>
        </Form>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(EditSensorPage);
